import { BarceloComponent } from "components-utils";

const AllBrhBase = {
  brhGridContainer: BarceloComponent({
    selector: ".brh-grid-container, .brh-grid-container-dl-id",
    path: "brh/base/brh-grid-container/js/brh-grid-container",
  }),

  brhMultimedia: BarceloComponent({
    selector: ".brh-multimedia, .brh-video, .brh-multimedia-dl-id",
    path: "brh/base/brh-multimedia/js/brh-multimedia",
  }),

  brhTitle: BarceloComponent({
    selector: ".brh-title__text, .brh-title__text-dl-id",
    path: "brh/base/brh-title/js/brh-title",
  }),

  brhCtaModal: BarceloComponent({
    selector: ".brh-cta-item, .brh-cta-item-dl-id",
    path: "brh/base/brh-cta/js/brh-cta",
  }),

  brhFastbooking: BarceloComponent({
    selector: ".brh-fastbooking, .brh-button--fastbooking, .brh-fastbooking-dl-id",
    path: "brh/base/brh-fastbooking/js/brh-fastbooking",
  }),

  brhParagraph: BarceloComponent({
    selector: ".brh-paragraph, .brh-paragraph-dl-id",
    path: "brh/base/brh-paragraph/js/brh-paragraph",
  }),

  brhSeparator: BarceloComponent({
    selector: ".brh-separator, .brh-separator-dl-id",
    path: "brh/base/brh-separator/js/brh-separator",
  }),

  brhTextIcon: BarceloComponent({
    selector: ".brh-text-icon, .brh-text-icon-dl-id",
    path: "brh/base/brh-text-icon/js/brh-text-icon",
  }),

  brhBreadcrumb: BarceloComponent({
    selector: ".brh-breadcrumb, .brh-breadcrumb-dl-id",
    path: "brh/base/brh-breadcrumb/js/brh-breadcrumb",
  }),
};

export default AllBrhBase;
